import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logEvent } from '@amplitude/analytics-browser';
import { TFunction } from 'i18next';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '../../componentsv2/Typography';
import { bankingEvents } from '../../constants/events';
import { BANKING_CREATE_TRANSFER, BANKING_NEW_CONVERSION } from '../../constants/auth';
import { BankingDetails } from '../../types/banking';
import { AddFundsActionIcon, TransferActionIcon, ConvertActionIcon } from './client/icons';
import AddFundsDrawer from '../Banking/Dashboard/AddFundsDrawer';

type Props = {
  bankingInfo: BankingDetails | undefined;
  t: TFunction;
};

export default function BankingActions({ bankingInfo, t }: Props) {
  const navigate = useNavigate();
  const [showAddFundsDrawer, setShowAddFundsDrawer] = useState(false);

  return (
    <>
      <Grid item xs={12} sx={{ paddingTop: '8px !important' }}>
        <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <Box
            onClick={() => {
              setShowAddFundsDrawer(true);
              logEvent(bankingEvents.OPEN_ADD_FUNDS);
            }}
            sx={{
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              px: '16px',
              py: '10px',
              borderRadius: '50px',
              backgroundColor: '#1C3553',
              userSelect: 'none',
              '&:hover': { backgroundColor: '#162A44' },
            }}
          >
            <AddFundsActionIcon />
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'white' }}>
              {t('banking-page:actions.addFunds')}
            </Typography>
          </Box>
          <Box
            onClick={() => {
              navigate(BANKING_CREATE_TRANSFER);
              logEvent(bankingEvents.OPEN_CREATE_TRANSFER);
            }}
            sx={{
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              px: '16px',
              py: '10px',
              borderRadius: '50px',
              backgroundColor: '#EEF1F8',
              userSelect: 'none',
              '&:hover': { backgroundColor: '#E3E8F3' },
            }}
          >
            <TransferActionIcon />
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#283952' }}>
              {t('banking-page:actions.transfer')}
            </Typography>
          </Box>
          <Box
            onClick={() => {
              navigate(BANKING_NEW_CONVERSION);
              logEvent(bankingEvents.OPEN_CREATE_CONVERSION);
            }}
            sx={{
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              px: '16px',
              py: '10px',
              borderRadius: '50px',
              backgroundColor: '#EEF1F8',
              userSelect: 'none',
              '&:hover': { backgroundColor: '#E3E8F3' },
            }}
          >
            <ConvertActionIcon />
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#283952' }}>
              {t('banking-page:actions.convert')}
            </Typography>
          </Box>
        </Box>
      </Grid>

      {bankingInfo && (
        <AddFundsDrawer
          show={showAddFundsDrawer}
          handleClose={() => setShowAddFundsDrawer(false)}
          t={t}
          connectedAccount={bankingInfo}
        />
      )}
    </>
  );
}
